import { h } from 'preact';

import { connect } from 'redux-zero/preact';

import actions from '../store/actions';

const Message = (props) => {
    if (!props.isValidToken) return

    const removeMessage = () => {
        props.changeForm({name:'message',value:''})
    }

        return (
            <div
                className="et-notification et-notification-top-center"
                role="alert"
            >
                <p className="et-font-bold">{props.message}</p>
                <button onClick={() => removeMessage()} className="et-notification-close" type="button" id="exit-warning"><svg width="14"
                        height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" data-svg="close-icon">
                        <line fill="none" stroke="#000" stroke-width="1.1" x1="1" y1="1" x2="13" y2="13"></line>
                        <line fill="none" stroke="#000" stroke-width="1.1" x1="13" y1="1" x2="1" y2="13"></line>
                    </svg>
                </button>
            </div>
        )
    }


export default connect(null, actions)(Message);